import React from 'react';
import './index.scss';
import PropTypes from 'prop-types';

const TextAreaLabelContract= React.forwardRef(({ className, onChange, value,labelMessage,readOnly, placeholder, ...props}, ref) =>{
    const onChangeValue = (event) => {
      event.preventDefault();
      if(onChange){
        onChange(event.target.value);
      }
    };
  return (
    <div ref={ref} className={`container-InputLabelContract ${className}`}>
        <label>{labelMessage}</label>
        <textarea required {...props} placeholder={placeholder} value={value}  onChange={onChangeValue} resize={false}/>
    </div>
  )

});

TextAreaLabelContract.displayName = 'TextAreaLabelContract';

TextAreaLabelContract.defaultProps = {
  className: '',
  placeholder: '',
  value: '',
  onChange: () => {},
  labelMessage : 'Correo',
};

TextAreaLabelContract.propTypes = {
  onChange: PropTypes.func,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  labelMessage: PropTypes.string,
};

export default TextAreaLabelContract;
